import {
	SOCIAL_INSURANCE_REDUCTION_THRESHOLD,
	SOCIAL_INSURANCE_REDUCTION_MULTIPLIERS,
} from './Constants';

import getThresholdPartial from './getThresholdPartial';

export function getSocialInsuranceDailyBase({
	income,
	year,
	thresholds = SOCIAL_INSURANCE_REDUCTION_THRESHOLD[year],
	multipliers = SOCIAL_INSURANCE_REDUCTION_MULTIPLIERS[year],
	full = false,
}) {
	const partials = thresholds.map((threshold, index, thresholds) => {
		const previousThreshold = thresholds[index - 1] || 0;
		const incomeAbovePreviousThreshold = income - previousThreshold;
		const thresholdRange = threshold - previousThreshold;
		const partial = getThresholdPartial(
			incomeAbovePreviousThreshold,
			thresholdRange,
			multipliers[index],
		);
		return partial;
	});

	if (full) {
		return partials;
	}

	return Math.ceil(partials.reduce((acc, value) => acc + value, 0));
}
